"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolletExtensionAdapter = void 0;
const tslib_1 = require("tslib");
const sol_wallet_adapter_1 = (0, tslib_1.__importDefault)(require("@project-serum/sol-wallet-adapter"));
class SolletExtensionAdapter extends sol_wallet_adapter_1.default {
    constructor(_providerURL, network) {
        super((() => {
            const sollet = window.sollet;
            if (!sollet) {
                throw new Error("Sollet extension not found");
            }
            return sollet;
        })(), network);
    }
}
exports.SolletExtensionAdapter = SolletExtensionAdapter;
//# sourceMappingURL=index.js.map